export const SYSTEM_MESSAGE_LOAD_STARTED = 'SYSTEM_MESSAGE_LOAD_STARTED';
export const SYSTEM_MESSAGE_LOAD_FAILED = 'SYSTEM_MESSAGE_LOAD_FAILED';
export const SYSTEM_MESSAGE_LOAD_SUCCESS = 'SYSTEM_MESSAGE_LOAD_SUCCESS';
